<!-- header -->
<sign-up-header></sign-up-header>

<!-- main content -->
<div class="main-content-container" [style.margin-bottom.px]="50">
    <div class="container-spaced">

        <!-- 1st column: Features -->
        <!--<options [package]="packageType" [licenseType]="licenseType"></options>-->

        <!-- 2nd column: Start Plan View -->
        <div class="main-container cnt-column-centered g4Border">

            <!-- Sign-up steps -->
            <!--<sign-up-steps [fourthForm]="true" [licenseType]="licenseType"></sign-up-steps>-->

            <!-- Main container -->
            <div class="create-account-bgrnd" [style.padding]="0" data-testid="winRegister" #renderDiv>

                <!-- Main container content -->
                <div class="cnt-column-centered">
                    <newplan-form *ngIf="authData" #newplanForm [isShowClose]="false" [authData]='authData' [dialogCreator]='dialogCreator' [renderForSignup]="true"></newplan-form>
                </div>
            </div>
        </div>
    </div>
</div>